import React from 'react'
import Heading from "../Typography/Heading";
import {
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../../../sections/Public/shared/publicLayoutSpec";

const ImageWithTopText = ({ TopText, classNames }) => {
  return (
    <>
      <div className={`tp-container-main mx-auto ${PUBLIC_SECTION_GAP_CLASS}`}>
        <Heading variant={"h2"} className={"text-offblack"}>
          {TopText}
        </Heading>
      </div>
      <div
        className={`tp-container-main mx-auto ${classNames} ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
      >
      <img
        src={require("../../../assets/img/about-us.jpg")}
        className={`rounded-xl object-cover w-full h-full`}
        alt=""
      />

      </div>
    </>
  )
}

export default ImageWithTopText